<div class="wrapper">

  <app-header #header ></app-header>
  <app-navmenu></app-navmenu>
     
  <div class="content-wrapper" style="background-color: #ecf0f5;">
    <div class="content" >
      <div class="container-fluid p-2">
        <router-outlet>
          <span class="loader" *ngIf="loading"></span>
          <ngx-spinner></ngx-spinner>
        </router-outlet>
      </div>
    </div>
  </div>
  <app-footer ></app-footer>

</div>